import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { BodyTextSmall } from '@modernhealth/vital-components';
import { BannerContentCard } from 'src/modules/dashboard/components/BannerContentCard';
import { ContentCollectionRenderComponent } from 'src/generated/webapp_gql';
import { ScreenSectionFragment } from 'src/modules/dashboard/documents/getHomeScreen.generated';
import { WellbeingReportHeader } from './WellbeingReportHeader';
import { CareCardPropsWithId, CareCardRow } from 'src/modules/care/components/CareCardRow';
import { mapContentLinkToRecommendedNextStepProps } from 'src/modules/dashboard/helpers/contentLinkNodeToCareCard';

export const WellbeingRenderScreenSectionNode: FC<{
    section: ScreenSectionFragment | null;
}> = ({ section }) => {
    const { t } = useTranslation();
    if (!section) return null;

    const Section = () => {
        switch (section.renderComponent) {
            case ContentCollectionRenderComponent.Banner:
                return <BannerContentCard links={section.contentCollectionLinks} />;
            case ContentCollectionRenderComponent.RecommendedNextStepBanner:
                return (
                    <CareCardRow
                        cards={section.contentCollectionLinks
                            .map(mapContentLinkToRecommendedNextStepProps)
                            .filter((link): link is CareCardPropsWithId => link !== null)}
                    />
                );
            default:
                return null;
        }
    };

    return (
        <>
            <WellbeingReportHeader title={section.title} />
            <BodyTextSmall marginBottom={24}>
                {t('assessments:wellbeing_report.recommendation.description')}
            </BodyTextSmall>
            <Section />
        </>
    );
};
